import type { LastUsedLabel } from '../lib/lastUsed'

/** The dot only reinforces the text, which says it in words. */
export default function LastUsedValue({ label }: { label: LastUsedLabel }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${label.recorded ? '' : 'text-gray-500'}`}
      title={label.title}
    >
      <span
        aria-hidden="true"
        className={`h-2 w-2 flex-shrink-0 rounded-full ${label.recorded ? 'bg-green-500' : 'border border-gray-400'}`}
      />
      {label.text}
    </span>
  )
}
